"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Personalize = void 0;
var cross_fetch_1 = __importDefault(require("cross-fetch"));
var build_info_1 = __importDefault(require("./build-info"));
var edge_api_errors_1 = require("./edge-api.errors");
var event_ingestion_type_1 = require("./event-ingestion.type");
var PROJECT_UID_HEADER_KEY = 'X-Project-Uid';
var USER_UID_HEADER_KEY = 'X-CS-Personalize-User-Uid';
var USER_UID_COOKIE_KEY = 'cs-personalize-user-uid';
var USER_UID_COOKIE_MAX_AGE = 365;
var MANIFEST_COOKIE_KEY = 'cs-personalize-manifest';
var REFERER_HEADER_KEY = 'Referer';
var PAGE_URL_HEADER_KEY = 'X-Page-Url';
var X_FORWARDED_FOR_HEADER_KEY = 'X-Forwarded-For';
var USER_AGENT_HEADER_KEY = 'User-Agent';
var COOKIE_HEADER_KEY = 'Cookie';
var SET_COOKIE_HEADER_KEY = 'Set-Cookie';
var CS_PERSONALIZE_PREFIX = 'cs_personalize';
var X_USER_AGENT = 'X-User-Agent';
var X_USER_AGENT_VALUE = "personalize-edge-sdk-js/".concat(build_info_1["default"].version);
var Personalize;
(function (Personalize) {
    var _edgeApiURL = 'https://personalize-edge.contentstack.com';
    var _isBrowserEnvironment = false;
    var _projectUid;
    var _userId;
    var _clientAttributes = {};
    var _manifestData;
    var _initializationDeferredPromise;
    var _initializationStatus;
    /**
     * Query parameter name for passing Personalize variants to the origin
     * server from your edge function. You can customize this parameter by
     * passing a different parameter when initializing the SDK with `init(projectUid, options)`.
     *
     * @example
     * ```ts
     * url.searchParams.set(Personalize.VARIANT_QUERY_PARAM, variantParam);
     * ```
     */
    Personalize.VARIANT_QUERY_PARAM = 'personalize_variants';
    /**
     * Initialize the Personalize SDK
     *
     * `init()` should be called and `await`ed before setting attributes, triggering
     * events or fetching variants. The SDK will make a call to fetch the manifest
     * during initialization. If the SDK is running in a browser environment and
     * a manifest cookie is already present (for e.g. the cookie is added by `addStateToResponse()` method),
     * then the SDK will not make a call and fetch the manifest directly from the cookie.
     *
     * @param projectUid - Project UID, find this in the Personalize project settings
     * @param options - Initialization options
     *
     * @example
     * ```ts
     * await Personalize.init(projecUid, { request });
     * ```
     */
    function init(projectUid, options) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var userIdFromCookie, cookieString, manifestFromCookie, parsedManifestFromCookie, _c, manifest, userId, error_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        setInitializationStatus('initializing');
                        buildInitializationDeferredPromise();
                        _isBrowserEnvironment = isBrowserEnvironment();
                        _projectUid = projectUid;
                        if (options === null || options === void 0 ? void 0 : options.request) {
                            cookieString = options.request.headers.get(COOKIE_HEADER_KEY);
                            if (cookieString) {
                                userIdFromCookie = getCookieValueByName(USER_UID_COOKIE_KEY, cookieString);
                            }
                        }
                        else {
                            userIdFromCookie = getValueFromCookies(USER_UID_COOKIE_KEY);
                        }
                        manifestFromCookie = getValueFromCookies(MANIFEST_COOKIE_KEY);
                        _userId = (_b = (_a = options === null || options === void 0 ? void 0 : options.userId) !== null && _a !== void 0 ? _a : userIdFromCookie) !== null && _b !== void 0 ? _b : _userId;
                        if (options === null || options === void 0 ? void 0 : options.customVariantQueryParam) {
                            Personalize.VARIANT_QUERY_PARAM = options.customVariantQueryParam;
                        }
                        if (!manifestFromCookie) return [3 /*break*/, 1];
                        parsedManifestFromCookie = JSON.parse(manifestFromCookie);
                        _manifestData = parsedManifestFromCookie;
                        if (!parsedManifestFromCookie.experiences) {
                            _manifestData.experiences = Object.keys(_manifestData.activeVariants).map(function (shortUid) { return ({
                                shortUid: shortUid,
                                activeVariantShortUid: _manifestData.activeVariants[shortUid]
                            }); });
                        }
                        return [3 /*break*/, 5];
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetchManifest(options === null || options === void 0 ? void 0 : options.request)];
                    case 2:
                        _c = _d.sent(), manifest = _c.manifest, userId = _c.userId;
                        _manifestData = manifest;
                        _userId = userId;
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _d.sent();
                        setInitializationStatus('error');
                        throw error_1;
                    case 4:
                        if (_isBrowserEnvironment) {
                            document.cookie = generateCookie(USER_UID_COOKIE_KEY, _userId, {
                                days: USER_UID_COOKIE_MAX_AGE
                            });
                        }
                        _d.label = 5;
                    case 5:
                        resolveAndResetInitializationPromise();
                        setInitializationStatus('success');
                        return [2 /*return*/];
                }
            });
        });
    }
    Personalize.init = init;
    /**
     * Change the Edge API URL. Useful if you want to point to a different ContentStack environment.
     *
     * Call this method before initializing the SDK.
     *
     * @param edgeApiUrl - Edge API URL
     * @example
     * ```ts
     * Personalize.setEdgeApiUrl('https://eu-personalize-edge.contentstack.com');
     * await Personalize.init(projectUid);
     * ```
     */
    function setEdgeApiUrl(edgeApiUrl) {
        _edgeApiURL = edgeApiUrl;
    }
    Personalize.setEdgeApiUrl = setEdgeApiUrl;
    /**
     * Gets the active experiences
     *
     * Returns a list of experience and corresponding active variant short UIDs.
     *
     * An inactive experience will have `null` in the corresponding `activeVariantShortUid`.
     *
     * The list is sorted in the order of experience priority. The experiences higher in the
     * list have higher priority.
     *
     * Call this method after initializing the SDK.
     *
     * @returns The active experiences
     * @example
     * ```ts
     * Personalize.getExperiences(); // [{shortUid: 'a', activeVariantShortUid: '0'}]
     * ```
     */
    function getExperiences() {
        var initStatus = getInitializationStatus();
        if (initStatus != 'success') {
            throw new Error('Cannot get experiences before initialization');
        }
        return _manifestData.experiences;
    }
    Personalize.getExperiences = getExperiences;
    /**
     * Triggers an impression
     *
     * The `triggerImpression` method triggers an impression for a given experience. The impression
     * is sent for the active variant in the manifest. Call this method whenever an experience is
     * shown to the user.
     *
     * Call this method after initializing the SDK.
     *
     * @param experienceShortUid - The experience short UID to trigger the impression for.
     * @example
     * ```ts
     * const experienceShortUid = 'a';
     * await Personalize.triggerImpression(experienceShortUid);
     * ```
     */
    function triggerImpression(experienceShortUid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, triggerImpressions({
                        experienceShortUids: [experienceShortUid]
                    })];
            });
        });
    }
    Personalize.triggerImpression = triggerImpression;
    /**
     * Triggers impressions
     *
     * The `triggerImpressions` method triggers multiple impressions for the given input. If provided
     * with Experience Short Uids, the impression is sent for the corresponding active variants in the manifest.
     * If provided wih Variant Aliases instead, it will use the Experience Short UID and Variant Short UID in the
     * alias to trigger impressions, without referring to the manifest.
     *
     * Call this method whenever an experience is shown to the user.
     *
     * Call this method after initializing the SDK.
     *
     * @param triggerImpressionOptions - Trigger Impression Options, one of
     * `experienceShortUids` or `aliases` must be given.
     * @example
     * ```ts
     * const experienceShortUids = ['a', 'b'];
     * await Personalize.triggerImpressions({ experienceShortUids });
     * await Personalize.triggerImpressions({ aliases: ['cs_personalize_a_0', 'cs_personalize_b_1'] });
     * ```
     */
    function triggerImpressions(triggerImpressionOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var initStatus, experienceAndVariants, impressions;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        initStatus = getInitializationStatus();
                        if (!initStatus) {
                            throw new Error('Cannot trigger impression before initialization');
                        }
                        if (!triggerImpressionOptions.aliases && !triggerImpressionOptions.experienceShortUids) {
                            throw new Error('Cannot trigger impression without options');
                        }
                        if (!(initStatus === 'initializing')) return [3 /*break*/, 2];
                        return [4 /*yield*/, waitForInit()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        if (triggerImpressionOptions.aliases) {
                            experienceAndVariants = triggerImpressionOptions.aliases
                                .map(getExperienceAndVariantFromAlias);
                        }
                        else {
                            experienceAndVariants = triggerImpressionOptions.experienceShortUids
                                .map(function (experienceShortUid) { return ({
                                experienceShortUid: experienceShortUid,
                                variantShortUid: getActiveVariant(experienceShortUid)
                            }); });
                        }
                        impressions = experienceAndVariants
                            .filter(function (experienceAndVariant) { return !!experienceAndVariant.variantShortUid; })
                            .map(function (_a) {
                            var experienceShortUid = _a.experienceShortUid, variantShortUid = _a.variantShortUid;
                            return {
                                experienceShortUid: experienceShortUid,
                                variantShortUid: variantShortUid,
                                type: event_ingestion_type_1.IngestEventType.IMPRESSION
                            };
                        });
                        return [4 /*yield*/, (0, cross_fetch_1["default"])("".concat(_edgeApiURL, "/events"), {
                                method: 'POST',
                                headers: (_a = {},
                                    _a[PROJECT_UID_HEADER_KEY] = _projectUid,
                                    _a[USER_UID_HEADER_KEY] = _userId,
                                    _a[X_USER_AGENT] = X_USER_AGENT_VALUE,
                                    _a),
                                body: JSON.stringify(impressions)
                            })];
                    case 3:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    Personalize.triggerImpressions = triggerImpressions;
    /**
     * Trigger an event
     *
     * An event is any significant action performed by the user such as clicking on the CTA,
     * scrolling to the end of the page, etc. The event is triggered by passing an `eventKey`,
     * which is used to create the event in the Personalize Management console. Triggering events
     * allow you to measure conversions for an A/B test.
     *
     * Call this method after initializing the SDK.
     *
     * @param eventKey - The key to trigger an event for. Ensure that an event with this key is
     * created in Personalize.
     * @example
     * ```ts
     * await Personalize.triggerEvent('clickCTA');
     * ```
     */
    function triggerEvent(eventKey) {
        return __awaiter(this, void 0, void 0, function () {
            var initStatus, customEvent;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        initStatus = getInitializationStatus();
                        if (!initStatus) {
                            throw new Error('Cannot trigger event before initialization');
                        }
                        if (!(initStatus === 'initializing')) return [3 /*break*/, 2];
                        return [4 /*yield*/, waitForInit()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        customEvent = {
                            eventKey: eventKey,
                            type: event_ingestion_type_1.IngestEventType.CUSTOM_EVENT
                        };
                        return [4 /*yield*/, (0, cross_fetch_1["default"])("".concat(_edgeApiURL, "/events"), {
                                method: 'POST',
                                headers: (_a = {},
                                    _a[PROJECT_UID_HEADER_KEY] = _projectUid,
                                    _a[USER_UID_HEADER_KEY] = _userId,
                                    _a[X_USER_AGENT] = X_USER_AGENT_VALUE,
                                    _a),
                                body: JSON.stringify([customEvent])
                            })];
                    case 3:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    Personalize.triggerEvent = triggerEvent;
    /**
     * Set custom user attributes
     *
     * User attributes are key-value pairs describing user traits. To use the set attributes,
     * you must create the attribute with the same key in the Personalize Management console.
     *
     * This method can only be called after initializing the SDK.
     *
     * @param clientAttributes - Attributes set on the client. Must be an object.
     * @example
     * ```ts
     * await Personalize.set({ age: 20 });
     * ```
     */
    function set(clientAttributes) {
        return __awaiter(this, void 0, void 0, function () {
            var initStatus;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        initStatus = getInitializationStatus();
                        if (!initStatus) {
                            throw new Error('Cannot set user attributes before initialization');
                        }
                        if (!(initStatus === 'initializing')) return [3 /*break*/, 2];
                        return [4 /*yield*/, waitForInit()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        _clientAttributes = __assign(__assign({}, _clientAttributes), clientAttributes);
                        return [4 /*yield*/, setUserAttributesOnEdge(_clientAttributes)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    Personalize.set = set;
    /**
   * Sets the `userId`
   *
   * The `userId` is used to identify the current user. It is automatically generated at the edge
   * when initializing the SDK for the first time.
   *
   * Use this method when you want to identify the current user with an externally managed user ID.
   * For e.g., you can use this when an anonymous user logs in.
   *
   * When an anonymous user logs in, you may also want to preserve all the user attributes tracked thus far.
   * The option `preserveUserAttributes` is available for the same, which merges all the attributes from
   * the current user.
   *
   * The `setUserId` method also drops a cookie to track the user ID in browser environments. The cookie
   * is called `cs-personalize-user-id`.
   *
   * Call this method before or after initializing the SDK.
   *
   * @param userId - The new user ID for the current user
   * @param options - Pass options to preserve user attributes
   * @example
   * ```ts
   * await Personalize.setUserId(newUserId, { preserveUserAttributes: true });
   * ```
   */
    function setUserId(userId, options) {
        return __awaiter(this, void 0, void 0, function () {
            var source_user_uid, mergeUserAttrsBody;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        source_user_uid = _userId;
                        _userId = userId;
                        if (_isBrowserEnvironment) {
                            document.cookie = generateCookie(USER_UID_COOKIE_KEY, userId, {
                                days: USER_UID_COOKIE_MAX_AGE
                            });
                        }
                        if (!(source_user_uid && (options === null || options === void 0 ? void 0 : options.preserveUserAttributes))) return [3 /*break*/, 2];
                        mergeUserAttrsBody = {
                            sourceUserUid: source_user_uid,
                            targetUserUid: userId
                        };
                        return [4 /*yield*/, (0, cross_fetch_1["default"])("".concat(_edgeApiURL, "/user-attributes/actions/merge"), {
                                method: 'POST',
                                headers: (_a = {},
                                    _a[PROJECT_UID_HEADER_KEY] = _projectUid,
                                    _a[X_USER_AGENT] = X_USER_AGENT_VALUE,
                                    _a),
                                body: JSON.stringify(mergeUserAttrsBody)
                            })];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    }
    Personalize.setUserId = setUserId;
    /**
     * Get the current `userId`
     *
     * Call this method after initializing the SDK.
     *
     * @returns the `userId`, else returns undefined if no `userId` is present
     */
    function getUserId() {
        return _userId;
    }
    Personalize.getUserId = getUserId;
    /**
     * Check for the active variant in the given experience
     *
     * Given an experience short UID, return the activated variant short UID for that experience.
     *
     * This method can only be called after initializing the SDK.
     *
     * @param experienceShortUid - Experience Short UID. Can be obtained from the
     * Personalize Management Console in the experience details page, or from a variant alias.
     * @returns The short UID of the active variant, if no variant is active, returns `null`.
     * @example
     * ```ts
     * const activeVariant = Personalize.getActiveVariant(experienceShortUid);
     * ```
     */
    function getActiveVariant(experienceShortUid) {
        var _a;
        return (_a = _manifestData.experiences
            .find(function (manifestExperience) { return manifestExperience.shortUid === experienceShortUid; })) === null || _a === void 0 ? void 0 : _a.activeVariantShortUid;
    }
    Personalize.getActiveVariant = getActiveVariant;
    /**
     * Tells you the status of SDK initialization.
     *
     * The status transitions to `initializing` when the SDK is initialized.
     * Once the initialization is complete (the promise is fulfilled), the status
     * transitions to `success`. If there's an error initializing, it transitions to `error`.
     *
     * Use this method to avoid calling SDK methods before it is initialized.
     *
     * ```ts
     * const initializationPromise = Personalize.init(projectUid);
     *
     * Personalize.getInitializationStatus(); // `initializing`
     *
     * await initializationPromise;
     *
     * Personalize.getInitializationStatus(); // `success`
     * ```
     */
    function getInitializationStatus() {
        return _initializationStatus;
    }
    Personalize.getInitializationStatus = getInitializationStatus;
    /**
     * Adds `userId` and manifest as set-cookie headers to the response
     *
     * `addStateToResponse` is a useful helper method that takes a response object
     * and adds cookies to track the user. It also adds a cookie to track the current manifest
     * for the user.
     *
     * The helper is typically used in an edge function to track the user state. When used this way,
     * it also allows the Personalize SDK to be initialized in the browser without making a
     * call to fetch the manifest.
     *
     * Call this method after initializing the SDK.
     *
     * @param response - A Web standard response object
     * @example
     * ```ts
     * await Personalize.addStateToResponse(response);
     * ```
     */
    function addStateToResponse(response) {
        return __awaiter(this, void 0, void 0, function () {
            var initStatus, userIdCookie, manifestCookie;
            return __generator(this, function (_a) {
                initStatus = Personalize.getInitializationStatus();
                if (initStatus != 'success') {
                    throw new Error('Cannot add state to response before initialization');
                }
                userIdCookie = generateCookie(USER_UID_COOKIE_KEY, _userId, {
                    days: USER_UID_COOKIE_MAX_AGE,
                    path: '/'
                });
                manifestCookie = generateCookie(MANIFEST_COOKIE_KEY, JSON.stringify(_manifestData), { path: '/' });
                response.headers.append(SET_COOKIE_HEADER_KEY, userIdCookie);
                response.headers.append(SET_COOKIE_HEADER_KEY, manifestCookie);
                return [2 /*return*/];
            });
        });
    }
    Personalize.addStateToResponse = addStateToResponse;
    /**
     * Gets the active variants
     *
     * Returns a key-value pair of the active experience and variant short UIDs.
     *
     * An inactive experience will have `null` in the corresponding value.
     *
     * Call this method after initializing the SDK.
     *
     * @returns The active variants
     * @example
     * ```ts
     * Personalize.getVariants(); // {a: 0, b: 1}
     * ```
     */
    function getVariants() {
        var initStatus = getInitializationStatus();
        if (initStatus != 'success') {
            throw new Error('Cannot get variants before initialization');
        }
        return _manifestData.experiences.reduce(function (activeVariants, manifestExperience) {
            var _a;
            return __assign(__assign({}, activeVariants), (_a = {}, _a[manifestExperience.shortUid] = manifestExperience.activeVariantShortUid, _a));
        }, {});
    }
    Personalize.getVariants = getVariants;
    /**
     * Gets the active variant aliases
     *
     * Returns a list of active experiences as variant aliases. Variant aliases are used by
     * Personalize to identify a CMS variant. The aliases can be passed to the CMS Delivery API
     * to fetch the personalized variant of content entries.
     *
     * The order in the list reflects the priority of the variants. The aliases higher in the list
     * have higher priority.
     *
     * Call this method after initializing the SDK.
     *
     * @returns The active variant aliases
     * @example
     * ```ts
     * Personalize.getVariantAliases(); // ['cs_personalize_a_0', 'cs_personalize_b_1']
     * ```
     */
    function getVariantAliases() {
        var initStatus = getInitializationStatus();
        if (initStatus != 'success') {
            throw new Error('Cannot get variant aliases before initialization');
        }
        return getCompactAliases()
            .map(function (alias) { return "".concat(CS_PERSONALIZE_PREFIX, "_").concat(alias); });
    }
    Personalize.getVariantAliases = getVariantAliases;
    /**
     * Gets the active variant param
     *
     * Returns an opaque variant parameter that can be easily passed in the URL.
     *
     * The parameter is essentially a comma separated list of active experience / variant short UIDs.
     *
     * The variant param can be passed as a query parameter in the URL to send the list of variants
     * activated for the current user. This helper method is typically used in edge functions.
     *
     * Call this method after initializing the SDK.
     *
     * @returns The active variant param
     * @example
     * ```ts
     * Personalize.getVariantParam(); // 'a_0,b_1'
     * ```
     */
    function getVariantParam() {
        var initStatus = getInitializationStatus();
        if (initStatus != 'success') {
            throw new Error('Cannot get variant alias param before initialization');
        }
        return getCompactAliases().join(',');
    }
    Personalize.getVariantParam = getVariantParam;
    /**
     * Convert a variant param to a list of variant aliases
     *
     * Returns alist of variant aliases from a variant param.
     *
     * The variant param can be passed as a query parameter in the URL to send the list of variants
     * activated for the current user. This helper method is typically used in server side code to decode
     * the variant parameter as a list of variant aliases that can be passed to the CMS Delivery API.
     *
     * @param variantParam - The variant param generated by `Personalize.getVariantParam()`
     * @returns The list of variant aliases
     * @example
     * ```ts
     * const variantParam = Personalize.getVariantParam(); // 'a_0,b_1'
     * Personalize.variantParamToVariantAliases(variantParam); // ['cs_personalize_a_0', 'cs_personalize_b_1']
     * ```
     */
    function variantParamToVariantAliases(variantParam) {
        return variantParam
            .split(',')
            .map(function (alias) { return "".concat(CS_PERSONALIZE_PREFIX, "_").concat(alias); });
    }
    Personalize.variantParamToVariantAliases = variantParamToVariantAliases;
    /**
   * Resets the SDK
   *
   * Calling this method resets the SDK to the original state. In particular:
   * - the manifest is deleted
   * - the `userId` is deleted
   * - any cookies in a browser environment are removed
   *
   * @example
   * ```ts
   * await Personalize.init(projectUid);
   * Personalize.getUserId(); // returns a random user ID
   * Personalize.reset();
   * Personalize.getUserId(); // returns `undefined`
   * ```
   */
    function reset() {
        _isBrowserEnvironment = isBrowserEnvironment();
        _userId = undefined;
        _manifestData = undefined;
        resetInitializationDeferredPromise();
        resetInitializationStatus();
        if (_isBrowserEnvironment) {
            removeCookie(USER_UID_COOKIE_KEY);
            removeCookie(MANIFEST_COOKIE_KEY);
        }
    }
    Personalize.reset = reset;
    /**
     * @ignore
     */
    function resetData() {
        _projectUid = undefined;
        _userId = undefined;
        _isBrowserEnvironment = false;
        _clientAttributes = {};
        _manifestData = undefined;
        resetInitializationDeferredPromise();
        resetInitializationStatus();
    }
    Personalize.resetData = resetData;
    function getCompactAliases() {
        return _manifestData
            .experiences
            .map(function (experience) { return "".concat(experience.shortUid, "_").concat(experience.activeVariantShortUid); });
    }
    function getExperienceAndVariantFromAlias(alias) {
        var _a = alias.split('_'), experienceShortUid = _a[2], _variantShortUid = _a[3];
        var variantShortUid = _variantShortUid === 'null' ? null : _variantShortUid;
        return { experienceShortUid: experienceShortUid, variantShortUid: variantShortUid };
    }
    function generateCookie(name, value, options) {
        var secondsInADay = 86400;
        var cookieString = "".concat(name, "=").concat(value);
        if (options === null || options === void 0 ? void 0 : options.days) {
            cookieString = "".concat(cookieString, "; Max-Age=").concat(options.days * secondsInADay);
        }
        if (options === null || options === void 0 ? void 0 : options.path) {
            cookieString = "".concat(cookieString, "; Path=").concat(options.path);
        }
        return cookieString;
    }
    function isBrowserEnvironment() {
        return typeof window !== 'undefined' && typeof document !== 'undefined';
    }
    function getValueFromCookies(cookieKey) {
        if (!_isBrowserEnvironment) {
            return null;
        }
        return getCookieValueByName(cookieKey, document.cookie);
    }
    function getCookieValueByName(name, cookieString) {
        var allCookies = cookieString.split(';');
        var userUidCookie = allCookies.find(function (cookie) { return cookie.trim().startsWith("".concat(name, "=")); });
        return userUidCookie ? userUidCookie.trim().split('=')[1] : null;
    }
    function removeCookie(name) {
        document.cookie = "".concat(encodeURIComponent(name), "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/");
    }
    function setUserAttributesOnEdge(userAttributes) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, (0, cross_fetch_1["default"])("".concat(_edgeApiURL, "/user-attributes"), {
                            method: 'PATCH',
                            headers: (_a = {},
                                _a[PROJECT_UID_HEADER_KEY] = _projectUid,
                                _a[USER_UID_HEADER_KEY] = _userId,
                                _a[X_USER_AGENT] = X_USER_AGENT_VALUE,
                                _a),
                            body: JSON.stringify(userAttributes)
                        })];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    }
    function fetchManifest(request) {
        return __awaiter(this, void 0, void 0, function () {
            var manifestRequestHeaders, pageUrl, referer, ipAddress, userAgent, manifestResponse, errorBody, userId, manifest;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        manifestRequestHeaders = (_a = {},
                            _a[PROJECT_UID_HEADER_KEY] = _projectUid,
                            _a);
                        pageUrl = getPageUrl(request);
                        if (pageUrl) {
                            manifestRequestHeaders[PAGE_URL_HEADER_KEY] = pageUrl;
                        }
                        referer = getReferer(request);
                        if (referer) {
                            manifestRequestHeaders[REFERER_HEADER_KEY] = referer;
                        }
                        ipAddress = getIPAddress(request);
                        if (ipAddress) {
                            manifestRequestHeaders[X_FORWARDED_FOR_HEADER_KEY] = ipAddress;
                        }
                        userAgent = getUserAgent(request);
                        if (userAgent) {
                            manifestRequestHeaders[USER_AGENT_HEADER_KEY] = userAgent;
                        }
                        if (_userId) {
                            manifestRequestHeaders[USER_UID_HEADER_KEY] = _userId;
                        }
                        manifestRequestHeaders[X_USER_AGENT] = X_USER_AGENT_VALUE;
                        return [4 /*yield*/, (0, cross_fetch_1["default"])("".concat(_edgeApiURL, "/manifest"), {
                                headers: manifestRequestHeaders
                            })];
                    case 1:
                        manifestResponse = _b.sent();
                        if (!!manifestResponse.ok) return [3 /*break*/, 4];
                        if (!(manifestResponse.status === 404)) return [3 /*break*/, 3];
                        return [4 /*yield*/, manifestResponse.json()];
                    case 2:
                        errorBody = _b.sent();
                        if (errorBody.error === edge_api_errors_1.ManifestError.PROJECT_NOT_FOUND) {
                            throw new Error("Project not found: ".concat(_projectUid));
                        }
                        _b.label = 3;
                    case 3: throw new Error("Could not fetch manifest: ".concat(manifestResponse.status));
                    case 4:
                        userId = manifestResponse.headers.get(USER_UID_HEADER_KEY);
                        return [4 /*yield*/, manifestResponse.json()];
                    case 5:
                        manifest = _b.sent();
                        return [2 /*return*/, { manifest: manifest, userId: userId }];
                }
            });
        });
    }
    function getPageUrl(req) {
        if (req === null || req === void 0 ? void 0 : req.url) {
            return req === null || req === void 0 ? void 0 : req.url;
        }
        return _isBrowserEnvironment ? document.URL : undefined;
    }
    function getReferer(req) {
        if (req === null || req === void 0 ? void 0 : req.headers.has(REFERER_HEADER_KEY)) {
            return req.headers.get(REFERER_HEADER_KEY);
        }
        return _isBrowserEnvironment ? document.referrer : undefined;
    }
    function getIPAddress(req) {
        if (req === null || req === void 0 ? void 0 : req.headers.has(X_FORWARDED_FOR_HEADER_KEY)) {
            return req.headers.get(X_FORWARDED_FOR_HEADER_KEY);
        }
    }
    function getUserAgent(req) {
        if (req === null || req === void 0 ? void 0 : req.headers.has(USER_AGENT_HEADER_KEY)) {
            return req.headers.get(USER_AGENT_HEADER_KEY);
        }
    }
    function buildInitializationDeferredPromise() {
        var resolvePromise;
        var rejectPromise;
        var promise = new Promise(function (resolve, reject) {
            resolvePromise = resolve;
            rejectPromise = reject;
        });
        _initializationDeferredPromise = {
            promise: promise,
            resolve: resolvePromise,
            reject: rejectPromise
        };
    }
    function resolveAndResetInitializationPromise() {
        if (_initializationDeferredPromise) {
            _initializationDeferredPromise.resolve();
        }
        resetInitializationDeferredPromise();
    }
    function resetInitializationDeferredPromise() {
        _initializationDeferredPromise = undefined;
    }
    function setInitializationStatus(initStatus) {
        _initializationStatus = initStatus;
    }
    function resetInitializationStatus() {
        _initializationStatus = undefined;
    }
    function waitForInit() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!_initializationDeferredPromise) return [3 /*break*/, 2];
                        return [4 /*yield*/, _initializationDeferredPromise.promise];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    }
})(Personalize = exports.Personalize || (exports.Personalize = {}));
//# sourceMappingURL=sdk.js.map